import React, { useState } from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useCurrentUserProfile } from "../utils";
import { useDarkMode } from "../App";
import VerifyEmailDialog from "./VerifyEmailDialog";
import "./VerifyEmailPlaceholder.css";

type Props = {
  /** Headline shown on the placeholder card. */
  title?: string;
  /** Explainer copy shown below the headline. */
  description?: string;
};

/**
 * Full-page placeholder rendered in place of gated surfaces (e.g. the create
 * listing form) when the signed-in user hasn't verified their email. Provides
 * self-serve without leaving the page (magic link emailed by auth-api).
 */
const VerifyEmailPlaceholder: React.FC<Props> = ({
  title = "Verify your email to continue",
  description = "We need to confirm your email address before you can take this action.",
}) => {
  const { profile, refetch } = useCurrentUserProfile();
  const { darkMode } = useDarkMode();
  const [open, setOpen] = useState(false);
  const token = typeof window !== "undefined" ? window.localStorage.getItem("token") : null;

  return (
    <div className={`verify-placeholder ${darkMode ? "dark" : ""}`}>
      <div className="verify-placeholder-card">
        <MailOutlineIcon className="verify-placeholder-icon" />
        <h2 className="verify-placeholder-title">{title}</h2>
        <p className="verify-placeholder-description">{description}</p>
        <button
          type="button"
          className="verify-placeholder-action"
          onClick={() => setOpen(true)}
          disabled={!token}
        >
          Verify now
        </button>
      </div>
      {token && (
        <VerifyEmailDialog
          open={open}
          token={token}
          email={profile?.email}
          darkMode={darkMode}
          onVerified={() => {
            setOpen(false);
            refetch();
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default VerifyEmailPlaceholder;
